import { RiseupMarket } from '@riseupil/costa-client';
import { SubscriptionStateEnum } from '@riseupil/billing-client';
import { defineStore } from 'pinia';
import moment from 'moment';
import { createCheckoutSession, createManagementPortal, getSubscription } from '../api/subscriptionApi';
import { SubscriptionStoreData } from '../types/subscription';
import config from '../config';

export const useSubscriptionStore = defineStore('subscription', {
  state: (): SubscriptionStoreData => ({
    loading: false,
    subscription: undefined,
    isSubscribed: false,
  }),
  getters: {
    isCancelled(): boolean {
      return (this.subscription?.canceledAt != null
          && moment().isAfter(moment(this.subscription?.canceledAt)))
        || this.subscription?.status === SubscriptionStateEnum.Dormant;
    },
    isFree(): boolean {
      return this.subscription?.status === SubscriptionStateEnum.Free;
    },
    isActiveOrTrial(): boolean {
      return this.subscription?.status === SubscriptionStateEnum.Active || this.subscription?.status === SubscriptionStateEnum.Trial;
    },
  },
  actions: {
    async createCheckoutUrl(fromApp: string, productId: string, coupon?: string | undefined) {
      this.loading = true;

      const successUrl = fromApp === 'true' ? 'https://static.letsriseup.com/subscription_finished'
        : `${config.get().billingPublicUrl}/success`;
      const url = await createCheckoutSession(
        RiseupMarket.enum.UK,
        [productId],
        successUrl,
        `${config.get().billingPublicUrl}/subscription`,
        coupon,
      );
      this.loading = false;
      return url;
    },
    async createManagementPortal(fromApp: string) {
      this.loading = true;
      const returnUrl = fromApp === 'true' ? 'https://static.letsriseup.com/subscription_finished'
        : `${config.get().billingPublicUrl}/subscription`;
      const url = await createManagementPortal(RiseupMarket.enum.UK, returnUrl);
      this.loading = false;
      return url;
    },
    async init() {
      const subscription = await getSubscription(RiseupMarket.enum.UK);
      if (subscription) {
        this.subscription = subscription;
        this.isSubscribed = true;
      }
    },
  },
});
